<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  
  export let isOpen = false
  export let changedFiles: number = 0
  export let needsPermission = false
  
  const dispatch = createEventDispatcher()
  
  function handleReloadFiles() {
    dispatch('reload-files')
  }
  
  function handleRefreshPage() {
    // Save current vault info before reload
    const vaultInfo = localStorage.getItem('selectedVault')
    if (vaultInfo) {
      sessionStorage.setItem('pendingVaultRestore', vaultInfo)
    }
    window.location.reload()
  }
  
  function handleRequestPermission() {
    dispatch('request-permission')
  }
  
  function handleClose() {
    isOpen = false
  }
</script>

{#if isOpen}
  <div 
    class="modal-overlay" 
    on:click={handleClose}
    on:keydown={(e) => e.key === 'Escape' && handleClose()}
    role="button"
    tabindex="-1"
    aria-label="Close modal overlay"
  >
    <div 
      class="modal-content" 
      on:click|stopPropagation
      on:keydown={(e) => e.key === 'Escape' && handleClose()}
      role="dialog"
      aria-labelledby="file-change-modal-title"
      tabindex="0"
    >
      <div class="modal-header">
        <h3 id="file-change-modal-title">파일 변경 감지</h3>
      </div>
      
      <div class="modal-body">
        {#if needsPermission}
          <p>외부에서 파일이 변경되어 접근 권한이 필요합니다.</p>
          <p class="sub-text">파일 동기화를 계속하려면 권한을 다시 부여해주세요.</p>
        {:else}
          <p><span class="highlight">{changedFiles}</span>개의 파일이 외부에서 변경되었습니다.</p>
          <p class="sub-text">변경사항을 반영하시겠습니까?</p>
        {/if}
      </div>
      
      <div class="modal-footer">
        {#if needsPermission}
          <button class="btn btn-secondary" on:click={handleClose}>
            나중에
          </button>
          <button class="btn btn-primary" on:click={handleRequestPermission}>
            권한 부여
          </button>
        {:else}
          <button class="btn btn-secondary" on:click={handleClose}>
            무시
          </button>
          <button class="btn btn-primary" on:click={handleReloadFiles}>
            파일 새로고침
          </button>
          <button class="btn btn-secondary" on:click={handleRefreshPage}>
            전체 새로고침
          </button>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.15s ease;
  }
  
  .modal-content {
    background: var(--bg-primary);
    border: 1px solid var(--border-primary);
    border-radius: 8px;
    padding: 20px;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    animation: slideUp 0.15s ease;
  }
  
  .modal-header {
    margin-bottom: 16px;
  }
  
  .modal-header h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 500;
    color: var(--text-primary);
  }
  
  .modal-body {
    margin-bottom: 20px;
  }
  
  .modal-body p {
    margin: 0 0 6px 0;
    color: var(--text-primary);
    font-size: 0.875rem;
    line-height: 1.4;
  }
  
  .highlight {
    color: var(--accent-primary);
    font-weight: 500;
  }
  
  .sub-text {
    color: var(--text-secondary);
    font-size: 0.8125rem;
  }
  
  .modal-footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }
  
  .btn {
    padding: 6px 14px;
    border-radius: 4px;
    font-size: 0.8125rem;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.15s;
    border: 1px solid transparent;
    outline: none;
  }
  
  .btn:focus-visible {
    outline: 2px solid var(--accent-primary);
    outline-offset: 1px;
  }
  
  .btn-primary {
    background: var(--accent-primary);
    color: white;
    border-color: var(--accent-primary);
  }
  
  .btn-primary:hover {
    background: var(--accent-primary);
    opacity: 0.9;
    filter: brightness(0.92);
    border-color: var(--accent-primary);
  }
  
  .btn-secondary {
    background: transparent;
    color: var(--text-secondary);
    border-color: var(--border-primary);
  }
  
  .btn-secondary:hover {
    background: var(--bg-secondary);
    color: var(--text-primary);
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(10px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>